module.exports = __webpack_public_path__ + "img/_54A6675.a2a0d2bb.jpg";